import { DatosTablas } from "./DatosTablasClimaAero";
import DatosClimaAeroMensual from "./DatosClimaAeroMensual";
import Papa from "papaparse";
import axios from "axios";

const TEST = 0;
const baseUrl = TEST
    ? "http://localhost:3000/"
    : "";

const estaciones = [
    {
        id: 39,
        nombre: "Carrasco - Aeropuerto Internacional Gral. Cesáreo L. Berisso",
        nombreCorto: "SUMU - Carrasco",
        nombreLargo: "Aeropuerto Internacional Gral. Cesáreo L. Berisso",
        dataFolder: "data_carrasco",
        periodo: "2015-2024",
        idOaci: "SUMU",
        ubicacion: "Canelones, Uruguay",
        elevacion: 32,
        operativa24h: true,
    },
    {
        id: 138,
        nombre: "Laguna del Sauce - Aeropuerto Internacional C/C Carlos A. Curbelo",
        nombreCorto: "SULS - Laguna del Sauce",
        nombreLargo: "Aeropuerto Internacional C/C Carlos A. Curbelo",
        dataFolder: "data_laguna_del_sauce",
        periodo: "2015-2024",
        idOaci: "SULS",
        ubicacion: "Maldonado, Uruguay",
        elevacion: 34,
        operativa24h: true,
    },
    {
        id: 96,
        nombre: "Durazno - Aeropuerto Internacional de Santa Bernardina",
        nombreCorto: "SUDU - Durazno",
        nombreLargo: "Aeropuerto Internacional de Santa Bernardina",
        dataFolder: "data_durazno",
        periodo: "2015-2024",
        idOaci: "SUDU",
        ubicacion: "Durazno, Uruguay",
        elevacion: 93,
        operativa24h: false,
        horaInicio: 10,
        horaFin: 20,
    },
    {
        id: 239,
        nombre: "Aeropuerto de Salto",
        nombreCorto: "SUSO - Salto",
        nombreLargo: "Aeropuerto Internacional de Nueva Hespérides",
        dataFolder: "data_salto",
        periodo: "2015-2024",
        idOaci: "SUSO",
        ubicacion: "Salto, Uruguay",
        elevacion: 39.55,
        operativa24h: false,
        horaInicio: 10,
        horaFin: 20,
    },
    {
        id: 500,
        nombre: "Melilla - Aeropuerto Internacional Ángel S. Adami",
        nombreCorto: "SUAA - Melilla",
        nombreLargo: "Aeropuerto Internacional Ángel S. Adami",
        dataFolder: "data_melilla",
        periodo: "2015-2024",
        idOaci: "SUAA",
        ubicacion: "Montevideo, Uruguay",
        elevacion: 53,
        operativa24h: false,
        horaInicio: 10,
        horaFin: 22,
    },
    {
        id: 501,
        nombre: "Colonia - Aeropuerto Internacional Laguna de los Patos",
        nombreCorto: "SUCA - Colonia",
        nombreLargo: "Aeropuerto Internacional Laguna de los Patos",
        dataFolder: "data_colonia",
        periodo: "2015-2024",
        idOaci: "SUCA",
        ubicacion: "Colonia, Uruguay",
        elevacion: 20,
        operativa24h: false,
        horaInicio: 10,
        horaFin: 20,
    },
];

function getEstacion(idEstacion) {
    const estacion = estaciones.find(e => e.id === idEstacion);
    return estacion;
}

function getNombreAeropuerto(idEstacion) {
    const estacion = getEstacion(idEstacion);
    return estacion ? estacion.nombre : null;
}

function getDataFolder(idEstacion) {
    const estacion = getEstacion(idEstacion);
    return estacion ? estacion.dataFolder : null;
}

function getEstaciones() {
    return estaciones;
}

const SALTO_ALT_FILENAMES = {
    Altura_nubes_frec_porc: "cloudtop_climatologia_SUSO_mes",
    Fenomenos_frec_abs: "sw_fenomenos_SUSO_mes",
    Temp_aire_frec_porc: "temp_bins_freq_mes",
    Visib_altura_nubes_frec_porc: "low_cloud_x_vis_SUSO_mes",
    Visibilidad_frec_porc: "visibilidad_horizontal_mes",
};

const SALTO_VIENTO_MONTH_FOLDERS = {
    1: "1-ENERO",
    2: "2-FEBRERO",
    3: "3-MARZO",
    4: "4-ABRIL",
    5: "5-MAYO",
    6: "6-JUNIO",
    7: "7-JULIO",
    8: "8-AGOSTO",
    9: "9-SETIEMBRE",
    10: "10-OCTUBRE",
    11: "11-NOVIEMBRE",
    12: "12-DICIEMBRE",
};

function pad2(value) {
    return value.toString().padStart(2, "0");
}

async function getTablaMesHora(idEstacion, iTabla, iMes, iHora) {
    const dataFolder = getDataFolder(idEstacion);
    if (!dataFolder) {
        throw new Error("Estación no encontrada");
    }

    const tablas = new DatosClimaAeroMensual(
        DatosTablas.titulosTablas[iTabla],
        DatosTablas.descripcionTablas[iTabla],
        DatosTablas.cantObs[iTabla],
        DatosTablas.titulosColsTablas[iTabla],
        DatosTablas.titulosCols2Tablas[iTabla],
        DatosTablas.tablasPorMesHora[iTabla]
    );
    if (DatosTablas.tablasPorMesHora[iTabla]) {
        let tablaMesHora = await fetchCsvMesHora(
            DatosTablas.prefijoNomarchivosTablas[iTabla],
            iMes + 1,
            iHora, dataFolder
        );
        tablas.addTabla(tablaMesHora);
    } else if (!DatosTablas.tablasPorMes[iTabla]) {
        let tablaMesHora = await fetchCsv(
            DatosTablas.prefijoNomarchivosTablas[iTabla], 0, dataFolder
        );
        tablas.addTabla(tablaMesHora);
    } else {
        let tablaMesHora = await fetchCsv(
            DatosTablas.prefijoNomarchivosTablas[iTabla],
            iMes + 1, dataFolder
        );
        tablas.addTabla(tablaMesHora);
    }
    return tablas;
}

async function fetchCsv(nombreVar, mes, dataFolder) {
    let path = baseUrl + dataFolder + "/" + nombreVar + "/" + nombreVar;

    if (mes > 0) path += "_" + mes.toString();
    let response;
    try {
        response = await axios.get(path + ".csv");
    } catch (error) {
        if (dataFolder === "data_salto" && mes > 0) {
            const saltoPrefix = SALTO_ALT_FILENAMES[nombreVar];
            if (saltoPrefix) {
                const altPath =
                    baseUrl +
                    dataFolder +
                    "/" +
                    nombreVar +
                    "/" +
                    saltoPrefix +
                    pad2(mes) +
                    ".csv";
                response = await axios.get(altPath);
            } else {
                throw error;
            }
        } else {
            throw error;
        }
    }

    const data = Papa.parse(response.data);
    let sinTitulo = data.data.slice(1);
    if (sinTitulo[sinTitulo.length - 1].length < 2)
        return sinTitulo.slice(0, sinTitulo.length - 1);
    return sinTitulo;
}

async function fetchCsvMesHora(nombreVar, mes, hora, dataFolder) {
    let path =
        baseUrl + dataFolder +
        "/" +
        nombreVar +
        "/" +
        mes +
        "/" +
        nombreVar +
        "_" +
        mes.toString() +
        "_" +
        hora.toString() +
        ".csv";
    let response;
    try {
        response = await axios.get(path);
    } catch (error) {
        if (dataFolder === "data_salto") {
            const saltoFolder = SALTO_VIENTO_MONTH_FOLDERS[mes];
            if (saltoFolder) {
                const altPath =
                    baseUrl +
                    dataFolder +
                    "/Viento/" +
                    saltoFolder +
                    "/dirxint_wind_SUSO_mes" +
                    pad2(mes) +
                    "_h" +
                    pad2(hora) +
                    "UTC.csv";
                response = await axios.get(altPath);
            } else {
                throw error;
            }
        } else {
            throw error;
        }
    }
    const data = Papa.parse(response.data);
    let sinTitulo = data.data.slice(1);
    if (sinTitulo[sinTitulo.length - 1].length < 2)
        return sinTitulo.slice(0, sinTitulo.length - 1);
    return sinTitulo;
}

export { getTablaMesHora, getEstaciones, getNombreAeropuerto, getEstacion };
